//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import AllThingsModule from 'app_components/modules/academic/allthings'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../webinarsScreen.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'

// @ADD Component types
interface IWebinarsScreenLayoutProps {}

const WebinarsScreenLayout: React.FC<IWebinarsScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <div className="webinars-screen--layout">
        <TextComponent type='title' as='h2' textTransform='none'>Webinar</TextComponent>
        <AllThingsModule type={'webinar'}/>
      </div>
    </PublicAppLayout>
  )
}

export default WebinarsScreenLayout
